import { Feedback } from 'react-common'
import { useTranslation } from 'react-i18next'
import styles from './FeedbackContainer.module.scss'
import { useFeedbackOptions } from './hooks/useFeedbackOptions'
import { useFeedbackSettings } from './hooks/useFeedbackSettings'
import { useHandleFeedbackSubmit } from './hooks/useHandleFeedbackSubmit'

export const FeedbackContainer = () => {
  const handleFeedbackSubmit = useHandleFeedbackSubmit()
  const options = useFeedbackOptions()
  const { visible } = useFeedbackSettings()

  const { t } = useTranslation()

  if (!visible) {
    return null
  }

  return (
    <div className={styles.container}>
      <Feedback
        translations={{
          startTitle: t('Feedback.rating.title'),
          checkboxesTitle: t('Feedback.checkboxes.title'),
          commentTitle: t('Feedback.comment.title'),
          thanksText: t('Feedback.thanks.description'),
        }}
        options={options}
        onSubmit={handleFeedbackSubmit}
      />
    </div>
  )
}
